import type { ADFEntity } from '@atlaskit/adf-utils/types';

export enum SnippetBodyFormat {
	ADF = 'ADF',
}

export enum SnippetProduct {
	CONFLUENCE = 'CONFLUENCE',
	JIRA = 'JIRA',
}

export enum SnippetScope {
	GLOBAL = 'GLOBAL',
	SITE = 'SITE',
	USER = 'USER',
}

export enum SnippetStatus {
	ACTIVE = 'ACTIVE',
	DELETED = 'DELETED',
}

export type SnippetData = {
	body: ADFEntity;
	bodyFormat: SnippetBodyFormat;
	createdAt: string; // String of integer timestamp
	createdBy: string;
	description?: string; // User defined name
	insertCount?: number;
	isFavorite: boolean;
	/** When true, template is shared with the site. Returned by BE for USER and SITE scope; may be omitted for GLOBAL */
	isShared?: boolean;
	label?: string;
	name: string; // User defined name
	product: SnippetProduct;
	resourceId: string; // ARI of the Snippet
	scope: SnippetScope;
	shareId?: string;
	snippetId: string;
	status: SnippetStatus;
	updatedAt: string; // String of integer timestamp
};

export type SnippetsProvider = {
	getSnippets: () => Promise<SnippetData[]>;
};
